import { useQuery } from "react-query";
import { toast } from "react-toastify";
import axios from "axios";
import { openingTimesUrls } from "../../URL/ApplicationUrls";
import OpeningTime, { OpeningTimeDto } from "../../OpeningTimes/OpeningTime";
import { IdType } from "../../Utils/IdType";
import { openingTimeWithIdQueryKey } from "../../OpeningTimes/openingTimeQueryKeys";
import { OpeningTimeMapper } from "../../OpeningTimes/OpeningTimeMapper";

export const useFetchOdcOpeningTimes = (parentId: IdType) => {
  return useQuery<OpeningTime[], Error>({
    queryKey: openingTimeWithIdQueryKey(parentId, "odcs"),
    queryFn: () => fetchOpeningTimesForOdc(parentId),
    onError: () => {
      toast.error(
        `An error occurred when retrieving opening times for the ODC with Id ${parentId}`
      );
    },
  });
};

const fetchOpeningTimesForOdc = async (parentId: IdType) => {
  const { data: openingTimesDtos } = await axios.get<OpeningTimeDto[]>(
    openingTimesUrls.openingTimesForODCsWithId(parentId)
  );

  return OpeningTimeMapper.toOpeningTimes(openingTimesDtos);
};
